module.exports = __webpack_public_path__ + "img/1597367337.9938d6ee.jpg";